import { render } from "./BackToButton.vue?vue&type=template&id=9ebc6cb2&scoped=true"
import script from "./BackToButton.vue?vue&type=script&lang=js"
export * from "./BackToButton.vue?vue&type=script&lang=js"

import "./BackToButton.vue?vue&type=style&index=0&id=9ebc6cb2&scoped=true&lang=css"
import "./BackToButton.vue?vue&type=style&index=1&id=9ebc6cb2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ebc6cb2"]])

export default __exports__